import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Skeleton, _CircularProgress;
var _excluded = ["sx"];
import React from 'react';
import { Box, CircularProgress, Container, Paper, Skeleton, Toolbar, extendSX } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * This is the Fallback component to render till the module is ready.
 */
export default function FallbackContainerPatientFormTemplateBuilder(_ref) {
  var sx = _ref.sx,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Container, _extends({
    maxWidth: false,
    disableGutters: true,
    sx: extendSX(sx, {
      display: 'flex',
      flexDirection: 'column'
    })
  }, props, {
    children: [/*#__PURE__*/_jsx(Paper, {
      sx: {
        width: '100%',
        borderRadius: 0
      },
      elevation: 1,
      children: /*#__PURE__*/_jsx(Toolbar, {
        sx: {
          width: '100%'
        },
        children: _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
          variant: "text",
          width: "160px"
        }))
      })
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        flex: 1,
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center'
      },
      children: _CircularProgress || (_CircularProgress = /*#__PURE__*/_jsx(CircularProgress, {}))
    })]
  }));
}